import { render, staticRenderFns } from "./RegisterProject.vue?vue&type=template&id=7d178cdc&scoped=true"
import script from "./RegisterProject.vue?vue&type=script&lang=js"
export * from "./RegisterProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d178cdc",
  null
  
)

export default component.exports